export const ALL_GRAPH_RECOMMENDATION_OFFER_TYPES_NO_LPP = ['hotel', 'tactical_ao_hotel', 'last_minute_hotel', 'bedbank_marriott']
export const ALL_GRAPH_RECOMMENDATION_OFFER_TYPES = ['hotel', 'tactical_ao_hotel', 'last_minute_hotel', 'bedbank', 'bedbank_marriott']
export const DESTINATION_DATA: Record<string, { type: string, imageId: string, name: string }> = {
  le_464adf7b911508701f4c4e70eab19a6e: {
    type: 'multi_city_vicinity',
    imageId: 'fkkgb9n9e17jhsm5ikm',
    name: 'Auckland',
  },
  le_d3d9446802a44259755d38e6d163e820: {
    type: 'country',
    imageId: 'oiyl17t2taq5d2fdz64',
    name: 'Australia',
  },
  le_64930b7151b6bc3e289f37d5da62ac9f: {
    type: 'province_state',
    imageId: 'vg4uvt2y5dgkivujuba6',
    name: 'Bali',
  },
  le_ff7aa1f9b4062bfee0f99a0453506f1b: {
    type: 'multi_city_vicinity',
    imageId: '7dx87h3ycow6orkyzsk',
    name: 'Bangkok',
  },
  le_ffe29c71e4cd3f141d8d80f82cbe4e72: {
    type: 'city',
    imageId: 'xgo4zx7duh1v0lv8otap',
    name: 'Batam',
  },
  le_b21d2f86beb192143a04671ac93bfd00: { type: 'city', imageId: 'zj5gyc22v3o45th4awwe', name: 'Bintan' },
  le_b96d145f6c31e35755f4a6841574ba37: {
    type: 'multi_city_vicinity',
    imageId: 'btx29u0kiwh5a6ob0m5',
    name: 'Brisbane',
  },
  le_8701b6eda0e8f334b30b4488214bbf1e: {
    type: 'city',
    imageId: 'uyhm9zdfpjlaopwx2mfy',
    name: 'Cancun',
  },
  le_d7bce4d8dbac13945471c343c4973ba3: {
    type: 'high_level_region',
    imageId: '54h7nft1vhh41svqcid',
    name: 'Caribbean',
  },
  le_3416a75f4cea9109507cacd8e2f2aefc: {
    type: 'country',
    imageId: 'x382u2epn5ub73h8l3',
    name: 'Cook Islands',
  },
  le_f9736cf40a30e0fe71c53004951da2ed: {
    type: 'multi_city_vicinity',
    imageId: 'eoo7x60icwbgndyc1wcge',
    name: 'Dubai',
  },
  le_43baa6762fa81bb43b39c62553b2970d: { type: 'province_state', imageId: 'eoo7x60icwbgndyc1wcge', name: 'Dubai' },
  le_12767faf1bf8cafc7594430586c558c2: {
    type: 'continent',
    imageId: 'iuuawzh6wih8s6hu6ss',
    name: 'Europe',
  },
  le_72b32a1f754ba1c09b3695e0cb6cde7f: {
    type: 'country',
    imageId: 'h1t0c6c9brq83bwhazx',
    name: 'Fiji',
  },
  le_eb163727917cbba1eea208541a643e74: {
    type: 'province_state',
    imageId: 'ponunzljvdk8z69ckkn',
    name: 'Florida',
  },
  le_bac732346917b0a1231354ef55faf00a: {
    type: 'city',
    imageId: 'krvovndggw4zalo1kgo8',
    name: 'Gold Coast',
  },
  le_735b90b4568125ed6c3f678819b6e058: {
    type: 'country',
    imageId: 'la8fpc5ehwxlh9cyd9ne',
    name: 'Greece',
  },
  le_979d472a84804b9f647bc185a877a8b5: {
    type: 'province_state',
    imageId: 'q26a5y2h5aijx52y8nfm',
    name: 'Hawaii',
  },
  le_93db85ed909c13838ff95ccfa94cebd9: {
    type: 'country',
    imageId: 'wbk1yjnf56awezs1lu',
    name: 'Italy',
  },
  le_7647966b7343c29048673252e490f736: {
    type: 'country',
    imageId: 'ri8b3umlvln1k6290g7i',
    name: 'Japan',
  },
  le_f3ad1c493ba61ad63bb43d6947f42d95: {
    type: 'city',
    imageId: 'hotel-destination-khao-lak',
    name: 'Khao Lak',
  },
  le_7af6d6117d13124fd3e00f5cb5f04400: {
    type: 'city',
    imageId: '2nic35dhw8gtasvlz29m',
    name: 'Koh Samui',
  },
  le_b536d75d9b756802546437b33b09b5e8: {
    type: 'city',
    imageId: 'plw9qs3zap66s5p4o6tc',
    name: 'Krabi',
  },
  le_f243f5a39d3b7ef531788ff07ea1ca58: {
    type: 'multi_city_vicinity',
    imageId: 'a9lyvzi0mmiwxy7nsgo',
    name: 'Kuala Lumpur',
  },
  le_2d405b367158e3f12d7c1e31a96b3af3: {
    type: 'province_state',
    imageId: 'search-destination-image-le_2d405b367158e3f12d7c1e31a96b3af3',
    name: 'Langkawi',
  },
  le_324d1d5faac07d0c5ae13c2213b84ea9: {
    type: 'multi_city_vicinity',
    imageId: 'r0zw0yiqmcs9te5d7yr',
    name: 'Las Vegas',
  },
  le_66ff0e7c30438d414ff0a941b759f114: {
    type: 'multi_city_vicinity',
    imageId: '2n47ppzghr6pannc4gm',
    name: 'London',
  },
  le_a3c65c2974270fd093ee8a9bf8ae7d0b: {
    type: 'country',
    imageId: 'jummelnit58g5ld7d8t9',
    name: 'Malaysia',
  },
  le_2723d092b63885e0d7c260cc007e8b9d: {
    type: 'country',
    imageId: 'dapbr82l65bcj5iy6v8',
    name: 'Maldives',
  },
  // le_6fc671d6a9900b46f5b5389ea2188e59: {
  //   type: 'high_level_region',
  //   imageId: undefined,
  //   name: 'Mallorca Island',
  // },
  le_2b44928ae11fb9384c4cf38708677c48: {
    type: 'country',
    imageId: 'ztyqafpx7lywouc2093',
    name: 'Mauritius',
  },
  le_15fa44474c92da27cf2125373356db4c: {
    type: 'multi_city_vicinity',
    imageId: 'asgz0fkt6cf311m98rq',
    name: 'Melbourne',
  },
  le_eb160de1de89d9058fcb0b968dbbbd68: {
    type: 'country',
    imageId: 'rasl0402sq9ft6vloi7b',
    name: 'Mexico',
  },
  le_8337a7365ec44f3d65434a5ea4d73d17: {
    type: 'province_state',
    imageId: '991vrkjubouwiyuerwjyr',
    name: 'New South Wales',
  },
  le_1ada7faf229425b786d87f7d9d5d43f2: {
    type: 'multi_city_vicinity',
    imageId: 'kgdhuqz8qk2dxsqm2rn',
    name: 'New York',
  },
  le_9fc3d7152ba9336a670e36d0ed79bc43: {
    type: 'country',
    imageId: '4ezeb1xkmkcuawwm0cf8',
    name: 'New Zealand',
  },
  le_a55472983efa2e239b315de91576d1d3: {
    type: 'city',
    imageId: 'hotel-destination-nusa-dua',
    name: 'Nusa Dua',
  },
  le_cb3f7087c987ceff5b306d4ff89f5db6: {
    type: 'multi_city_vicinity',
    imageId: '3r1eu1oz4snlmhci35gg',
    name: 'Paris',
  },
  le_d47bb339212ddfab0fadd99d492a5fc3: {
    type: 'province_state',
    imageId: 'u9x09v188fgl4s71edf',
    name: 'Phuket',
  },
  le_dc2afc2240bd3cd5067a740a2cb17399: {
    type: 'city',
    imageId: '9ejcktzro8pey77aew7s',
    name: 'Port Douglas',
  },
  le_3d3621cee6f49e93a34f3f0f654ab41a: {
    type: 'province_state',
    imageId: '68cb38dgpprmupvorvzg',
    name: 'Queensland',
  },
  le_5a4773830c5a9191a6bd6c301d060ad2: {
    type: 'city',
    imageId: '4vhgn44wotbycqrscpm8',
    name: 'Queenstown',
  },
  le_287643040f414c7ab7860c1b3f841149: {
    type: 'city',
    imageId: 'gxat5lulud6a8h60omlo',
    name: 'Rarotonga',
  },
  le_2a79ea27c279e471f4d180b08d62b00a: {
    type: 'country',
    imageId: 'kgp44kj57lap71v2djyt',
    name: 'Samoa',
  },
  le_790d9f1f52e10ef90ede8efcf7f3c078: {
    type: 'city',
    imageId: 'hotel-destination-seminyak',
    name: 'Seminyak',
  },
  le_ce393994e8cf430867408678d1a5a9c8: {
    type: 'city',
    imageId: 'b4u5c9v9eplflpfjohz8',
    name: 'Singapore',
  },
  le_bd4c9ab730f5513206b999ec0d90d1fb: {
    type: 'country',
    imageId: 'b4u5c9v9eplflpfjohz8',
    name: 'Singapore',
  },
  le_7e7757b1e12abcb736ab9a754ffb617a: {
    type: 'country',
    imageId: '7mxbm2s01q38r2900zj',
    name: 'Spain',
  },
  le_5878a7ab84fb43402106c575658472fa: {
    type: 'country',
    imageId: 'sbt77s6ibekmoctipeza',
    name: 'Sri Lanka',
  },
  le_678c61ac5b4f91ca86e112fc50e63766: {
    type: 'multi_city_vicinity',
    imageId: 'yomtdyqjjozztpjzjo',
    name: 'Sydney',
  },
  le_8f85517967795eeef66c225f7883bdcb: {
    type: 'country',
    imageId: 'lids8h5rs9zj2xvkxr',
    name: 'Thailand',
  },
  le_1608659ea7ec15440fa87763b3f5d700: {
    type: 'multi_city_vicinity',
    imageId: '55nbfq3aqpbyhnn16b5',
    name: 'Tokyo',
  },
  le_cedebb6e872f539bef8c3f919874e9d7: {
    type: 'country',
    imageId: 'idn0i6aj221ks5zsyyx',
    name: 'Turkey',
  },
  le_cfecdb276f634854f3ef915e2e980c31: {
    type: 'country',
    imageId: 'bh52x5crz46nt54uxsl',
    name: 'United Kingdom',
  },
  le_757b505cfd34c64c85ca5b5690ee5293: {
    type: 'country',
    imageId: '2agstgb25xcdai5sl2y',
    name: 'United States of America',
  },
  le_5781a2637b476d781eb3134581b32044: {
    type: 'province_state',
    imageId: '0h1arx6nnm0gslh04pba',
    name: 'Victoria',
  },
  le_a597e50502f5ff68e3e25b9114205d4a: {
    type: 'country',
    imageId: '7pmj8f3m1cz7ip3920k',
    name: 'Vietnam',
  },
  le_8d5e957f297893487bd98fa830fa6413: {
    type: 'country',
    imageId: 'cz7m94t6nxlhtmx6eba',
    name: 'Portugal',
  },
}
export interface RecommendationsListEntry {
  destinationId: string;
  destinationName: string;
  imageId: string;
}
const TOKYO_REC_DESTINATIONS = [
  { destinationId: 'le_dd6cfa36ca5f428a6c9824630d3a8a96', destinationName: 'Osaka', imageId: '79c28d90-1acf-4ca3-ad83-029f3718f35a' },
  { destinationId: 'le_c98e367e46aa4e7c4d6823b021865936', destinationName: 'Kyoto', imageId: 'b30a4363-5900-4aeb-980c-3dc405664476' },
  { destinationId: 'le_4d22dc28a212a9727b1637817a7e9748', destinationName: 'Hokkaido', imageId: '54b12da1-bbad-4fac-8597-9839598f6532' },
  { destinationId: 'le_ff3b33b71034eb7c9d5c014ccd771fbc', destinationName: 'Hiroshima', imageId: 'df9356c6-4d19-41fb-a698-60f75506fcec' },
  { destinationId: 'le_84a3cac633162a1efcc41009c099c53b', destinationName: 'Hakone', imageId: '49467f98-f083-4ca9-a3d5-8cd80e24ee5d' },
  { destinationId: 'le_e447193f2b83d789c98a82a7ef958736', destinationName: 'Urayasu', imageId: 'd02773a1-179d-41f3-8679-05416c66085a' },
]

const OSAKA_REC_DESTINATIONS = [
  { destinationId: 'le_cdd0500dc0ef6682fa6ec6d2e6b577c4', destinationName: 'Tokyo', imageId: '2d69b61d-4dae-4155-b48b-76cdbc2805c7' },
  { destinationId: 'le_c98e367e46aa4e7c4d6823b021865936', destinationName: 'Kyoto', imageId: 'b30a4363-5900-4aeb-980c-3dc405664476' },
  { destinationId: 'le_4d22dc28a212a9727b1637817a7e9748', destinationName: 'Hokkaido', imageId: '54b12da1-bbad-4fac-8597-9839598f6532' },
  { destinationId: 'le_ff3b33b71034eb7c9d5c014ccd771fbc', destinationName: 'Hiroshima', imageId: 'df9356c6-4d19-41fb-a698-60f75506fcec' },
  { destinationId: 'le_84a3cac633162a1efcc41009c099c53b', destinationName: 'Hakone', imageId: '49467f98-f083-4ca9-a3d5-8cd80e24ee5d' },
  { destinationId: 'le_e447193f2b83d789c98a82a7ef958736', destinationName: 'Urayasu', imageId: 'd02773a1-179d-41f3-8679-05416c66085a' },
]

const KYOTO_REC_DESTINATIONS = [
  { destinationId: 'le_cdd0500dc0ef6682fa6ec6d2e6b577c4', destinationName: 'Tokyo', imageId: '2d69b61d-4dae-4155-b48b-76cdbc2805c7' },
  { destinationId: 'le_dd6cfa36ca5f428a6c9824630d3a8a96', destinationName: 'Osaka', imageId: '79c28d90-1acf-4ca3-ad83-029f3718f35a' },
  { destinationId: 'le_4d22dc28a212a9727b1637817a7e9748', destinationName: 'Hokkaido', imageId: '54b12da1-bbad-4fac-8597-9839598f6532' },
  { destinationId: 'le_ff3b33b71034eb7c9d5c014ccd771fbc', destinationName: 'Hiroshima', imageId: 'df9356c6-4d19-41fb-a698-60f75506fcec' },
  { destinationId: 'le_84a3cac633162a1efcc41009c099c53b', destinationName: 'Hakone', imageId: '49467f98-f083-4ca9-a3d5-8cd80e24ee5d' },
  { destinationId: 'le_e447193f2b83d789c98a82a7ef958736', destinationName: 'Urayasu', imageId: 'd02773a1-179d-41f3-8679-05416c66085a' },
]

const SAN_FRANCISCO_REC_DESTINATIONS = [
  { destinationId: 'le_324d1d5faac07d0c5ae13c2213b84ea9', destinationName: 'Las Vegas', imageId: '7e4480a7-ad92-4036-acde-9066f6b7578e' },
  { destinationId: 'le_079230e29195cac1ce62e737740797a0', destinationName: 'Los Angeles', imageId: '6f3f4195-519e-4360-8f93-f3ec009b3607' },
  { destinationId: 'le_1ada7faf229425b786d87f7d9d5d43f2', destinationName: 'New York', imageId: '8ad03e09-12e3-448f-8894-773765e2c497' },
  { destinationId: 'le_979d472a84804b9f647bc185a877a8b5', destinationName: 'Hawaii', imageId: 'a40dea11-51c6-4c38-8bf1-68ba304392d8' },
  { destinationId: 'le_548026b063092cc5c30e6ea04ccef75c', destinationName: 'Miami', imageId: 'e0047d0a-4272-4457-85dc-30649ec65a1e' },
  { destinationId: 'le_077e29b11be80ab57e1a2ecabb7da330', destinationName: 'Washington', imageId: '556b2593-7ba5-4e0e-b3ed-f1547d0128dc' },
]

const LAS_VEGAS_REC_DESTINATIONS = [
  { destinationId: 'le_bd80d53a4b5d3aef9d8a1fabe2feecfc', destinationName: 'San Francisco', imageId: '9d00c89d-9328-46aa-9bea-7cc29aed4c45' },
  { destinationId: 'le_1ada7faf229425b786d87f7d9d5d43f2', destinationName: 'New York', imageId: '8ad03e09-12e3-448f-8894-773765e2c497' },
  { destinationId: 'le_079230e29195cac1ce62e737740797a0', destinationName: 'Los Angeles', imageId: '6f3f4195-519e-4360-8f93-f3ec009b3607' },
  { destinationId: 'le_979d472a84804b9f647bc185a877a8b5', destinationName: 'Hawaii', imageId: 'a40dea11-51c6-4c38-8bf1-68ba304392d8' },
  { destinationId: 'le_548026b063092cc5c30e6ea04ccef75c', destinationName: 'Miami', imageId: 'e0047d0a-4272-4457-85dc-30649ec65a1e' },
  { destinationId: 'le_8c5cc0fdae1f1087d70c03ae29e5acb9', destinationName: 'Boston', imageId: '049575cb-452a-41c9-8fef-49975391f505' },
]

const LOS_ANGELES_REC_DESTINATIONS = [
  { destinationId: 'le_1ada7faf229425b786d87f7d9d5d43f2', destinationName: 'New York', imageId: '8ad03e09-12e3-448f-8894-773765e2c497' },
  { destinationId: 'le_bd80d53a4b5d3aef9d8a1fabe2feecfc', destinationName: 'San Francisco', imageId: '9d00c89d-9328-46aa-9bea-7cc29aed4c45' },
  { destinationId: 'le_324d1d5faac07d0c5ae13c2213b84ea9', destinationName: 'Las Vegas', imageId: '7e4480a7-ad92-4036-acde-9066f6b7578e' },
  { destinationId: 'le_077e29b11be80ab57e1a2ecabb7da330', destinationName: 'Washington', imageId: '556b2593-7ba5-4e0e-b3ed-f1547d0128dc' },
  { destinationId: 'le_548026b063092cc5c30e6ea04ccef75c', destinationName: 'Miami', imageId: 'e0047d0a-4272-4457-85dc-30649ec65a1e' },
  { destinationId: 'le_979d472a84804b9f647bc185a877a8b5', destinationName: 'Hawaii', imageId: 'a40dea11-51c6-4c38-8bf1-68ba304392d8' },
]

const NEW_YORK_REC_DESTINATIONS = [
  { destinationId: 'le_079230e29195cac1ce62e737740797a0', destinationName: 'Los Angeles', imageId: '6f3f4195-519e-4360-8f93-f3ec009b3607' },
  { destinationId: 'le_bd80d53a4b5d3aef9d8a1fabe2feecfc', destinationName: 'San Francisco', imageId: '9d00c89d-9328-46aa-9bea-7cc29aed4c45' },
  { destinationId: 'le_8a146f1a3da4700cbf03cdc55e2daae6', destinationName: 'Hawaii', imageId: 'a40dea11-51c6-4c38-8bf1-68ba304392d8' },
  { destinationId: 'le_324d1d5faac07d0c5ae13c2213b84ea9', destinationName: 'Las Vegas', imageId: '7e4480a7-ad92-4036-acde-9066f6b7578e' },
  { destinationId: 'le_bd4c9ab730f5513206b999ec0d90d1fb', destinationName: 'Singapore', imageId: '73fe1362-f21b-4e6b-bfb1-ff070ff7b494' },
  { destinationId: 'le_51174add1c52758f33d414ceaf3fe6ba', destinationName: 'London', imageId: '43348077-c6e8-435a-9267-b8a44ab4f131' },
]

const LONDON_REC_DESTINATIONS = [
  { destinationId: 'le_cb3f7087c987ceff5b306d4ff89f5db6', destinationName: 'Paris', imageId: '3c8d96c5-2156-4b4b-8fcc-de773c4e3953' },
  { destinationId: 'le_f01722cf0682667d18119b2cdef492ad', destinationName: 'Edinburgh', imageId: '380f5a12-6633-4310-8009-9b90d0a89cc5' },
  { destinationId: 'le_af15ce7cbd279b1a769d85d1540a5073', destinationName: 'Barcelona', imageId: '525819c5-e063-49fe-867a-bcbad50b113e' },
  { destinationId: 'le_1651cf0d2f737d7adeab84d339dbabd3', destinationName: 'Athens', imageId: '1938bab0-d7d9-4fbc-9ae6-a29288cc9f4d' },
  { destinationId: 'le_09d37c08f7b129e96277388757530c72', destinationName: 'Rome', imageId: '59ce2bd0-362e-4cab-ade3-bf9e253ad553' },
  { destinationId: 'le_6754e06e46dfa419d5afe3c9781cecad', destinationName: 'Venice', imageId: '0bf5708f-2d61-45cc-9d0c-5bb994dd3dd1' },
]

const BARCELONA_REC_DESTINATIONS = [
  { destinationId: 'le_6832a7b24bc06775d02b7406880b93fc', destinationName: 'Madrid', imageId: 'd9f188c4-7656-49e6-9f6c-aca14e01d7d9' },
  { destinationId: 'le_51174add1c52758f33d414ceaf3fe6ba', destinationName: 'London', imageId: '43348077-c6e8-435a-9267-b8a44ab4f131' },
  { destinationId: 'le_54ff9e9e3a2ec0300d4ce11261f5169f', destinationName: 'Lisbon', imageId: 'fccad45b-3b0b-47d2-91d3-51650da2557a' },
  { destinationId: 'le_cb3f7087c987ceff5b306d4ff89f5db6', destinationName: 'Paris', imageId: '3c8d96c5-2156-4b4b-8fcc-de773c4e3953' },
  { destinationId: 'le_1651cf0d2f737d7adeab84d339dbabd3', destinationName: 'Athens', imageId: '1938bab0-d7d9-4fbc-9ae6-a29288cc9f4d' },
  { destinationId: 'le_334467d41d5cf21e234465a1530ba647', destinationName: 'Seville', imageId: '690639b5-072e-4cec-97fa-e6504b1c930e' },
]

const ROME_REC_DESTINATIONS = [
  { destinationId: 'le_cb3f7087c987ceff5b306d4ff89f5db6', destinationName: 'Paris', imageId: '3c8d96c5-2156-4b4b-8fcc-de773c4e3953' },
  { destinationId: 'le_51174add1c52758f33d414ceaf3fe6ba', destinationName: 'London', imageId: '43348077-c6e8-435a-9267-b8a44ab4f131' },
  { destinationId: 'le_6754e06e46dfa419d5afe3c9781cecad', destinationName: 'Venice', imageId: '0bf5708f-2d61-45cc-9d0c-5bb994dd3dd1' },
  { destinationId: 'le_3a029f04d76d32e79367c4b3255dda4d', destinationName: 'Florence', imageId: '5d3b5538-0508-4a75-abc6-a2ae650a9483' },
  { destinationId: 'le_ffedf5be3a86e2ee281d54cdc97bc1cf', destinationName: 'Milan', imageId: '88f4d716-2b85-4d50-b318-22b1b7818eed' },
  { destinationId: 'le_af15ce7cbd279b1a769d85d1540a5073', destinationName: 'Barcelona', imageId: '525819c5-e063-49fe-867a-bcbad50b113e' },
]
const EUROPE_GENERIC_REC_DESTINATIONS = [
  { destinationId: 'le_51174add1c52758f33d414ceaf3fe6ba', destinationName: 'London', imageId: '43348077-c6e8-435a-9267-b8a44ab4f131' },
  { destinationId: 'le_cb3f7087c987ceff5b306d4ff89f5db6', destinationName: 'Paris', imageId: '3c8d96c5-2156-4b4b-8fcc-de773c4e3953' },
  { destinationId: 'le_09d37c08f7b129e96277388757530c72', destinationName: 'Rome', imageId: '59ce2bd0-362e-4cab-ade3-bf9e253ad553' },
  { destinationId: 'le_af15ce7cbd279b1a769d85d1540a5073', destinationName: 'Barcelona', imageId: '525819c5-e063-49fe-867a-bcbad50b113e' },
  { destinationId: 'le_bd4c9ab730f5513206b999ec0d90d1fb', destinationName: 'Singapore', imageId: '73fe1362-f21b-4e6b-bfb1-ff070ff7b494' },
  { destinationId: 'le_43baa6762fa81bb43b39c62553b2970d', destinationName: 'Dubai', imageId: 'eb9c0214-513c-4a12-9025-c2d03eb71d4f' },
]
const PARIS_REC_DESTINATIONS = [
  { destinationId: 'le_51174add1c52758f33d414ceaf3fe6ba', destinationName: 'London', imageId: '43348077-c6e8-435a-9267-b8a44ab4f131' },
  { destinationId: 'le_09d37c08f7b129e96277388757530c72', destinationName: 'Rome', imageId: '59ce2bd0-362e-4cab-ade3-bf9e253ad553' },
  { destinationId: 'le_af15ce7cbd279b1a769d85d1540a5073', destinationName: 'Barcelona', imageId: '525819c5-e063-49fe-867a-bcbad50b113e' },
  { destinationId: 'le_8bf1211fd4b7b94528899de0a43b9fb3', destinationName: 'Amsterdam', imageId: '4e96e0e2-1138-4e28-a1f8-28dc2d6783c7' },
  { destinationId: 'le_1651cf0d2f737d7adeab84d339dbabd3', destinationName: 'Athens', imageId: '1938bab0-d7d9-4fbc-9ae6-a29288cc9f4d' },
  { destinationId: 'le_ffedf5be3a86e2ee281d54cdc97bc1cf', destinationName: 'Milan', imageId: '88f4d716-2b85-4d50-b318-22b1b7818eed' },
]

export const BOOKING_CONFIRMATION_REC_DESTINATIONS: Record<string, Record<string, Array<RecommendationsListEntry>>> = {
  le_8f85517967795eeef66c225f7883bdcb: /* Thailand */ {
    Generic: [
      { destinationId: 'le_d47bb339212ddfab0fadd99d492a5fc3', destinationName: 'Phuket', imageId: 'e26c1ee7-88b8-4835-bcb5-f8d2eb5cafd9' },
      { destinationId: 'le_9cf81d8026a9018052c429cc4e56739b', destinationName: 'Bangkok', imageId: '932bb8e0-26bf-4267-a249-7298ac2b39dd' },
      { destinationId: 'le_7af6d6117d13124fd3e00f5cb5f04400', destinationName: 'Koh Samui', imageId: '58a05961-5f6b-4c51-bd4c-b64fb6e881fe' },
      { destinationId: 'le_f3ad1c493ba61ad63bb43d6947f42d95', destinationName: 'Khao Lak', imageId: 'e542e945-0d19-4028-a123-92ae75d22cf0' },
      { destinationId: 'le_bd4c9ab730f5513206b999ec0d90d1fb', destinationName: 'Singapore', imageId: '73fe1362-f21b-4e6b-bfb1-ff070ff7b494' },
      { destinationId: 'le_b536d75d9b756802546437b33b09b5e8', destinationName: 'Krabi', imageId: '41754a34-4f54-4e75-8072-07926094e1d3' },
      { destinationId: 'le_f964e87e2c42208253412904eec37214', destinationName: 'Chiang Mai', imageId: 'f3cd4f24-be58-4e89-9d2c-e9d9f1cd82aa' },
    ],
  },
  le_a597e50502f5ff68e3e25b9114205d4a: /* Vietnam */ {
    Generic: [
      { destinationId: 'le_747d3443e319a22747fbb873e8b2f9f2', destinationName: 'Ho Chi Minh City', imageId: 'cc629b19-f66e-4d7e-8664-e689b86459fa' },
      { destinationId: 'le_e7708a01a999a96c804a6b3c122d31c0', destinationName: 'Hanoi', imageId: '77545fcc-5e80-42cb-a300-627defdd4301' },
      { destinationId: 'le_f6c8eb0a04b4edf33a261d7e3a984bcc', destinationName: 'Hoi An', imageId: '06939259-41ab-4c32-b10f-7a7fcaaef576' },
      { destinationId: 'le_4311359ed4969e8401880e3c1836fbe1', destinationName: 'Da Nang', imageId: '75d36b6b-3f16-4467-ab11-5285331a9d45' },
      { destinationId: 'le_1608659ea7ec15440fa87763b3f5d700', destinationName: 'Thailand', imageId: 'a5cc53e9-971e-4a7e-953a-33bda1c0cd84' },
      { destinationId: 'le_bd4c9ab730f5513206b999ec0d90d1fb', destinationName: 'Singapore', imageId: '73fe1362-f21b-4e6b-bfb1-ff070ff7b494' },
      { destinationId: 'le_ef9e7160514b136fca49362a95d52977', destinationName: 'Nha Trang', imageId: 'e6d7272a-a5b9-434a-95ee-d1eb3f10f387' },
    ],
  },
  le_7647966b7343c29048673252e490f736: /* Japan */ {
    Generic: [
      { destinationId: 'le_cdd0500dc0ef6682fa6ec6d2e6b577c4', destinationName: 'Tokyo', imageId: '2d69b61d-4dae-4155-b48b-76cdbc2805c7' },
      { destinationId: 'le_dd6cfa36ca5f428a6c9824630d3a8a96', destinationName: 'Osaka', imageId: '79c28d90-1acf-4ca3-ad83-029f3718f35a' },
      { destinationId: 'le_c98e367e46aa4e7c4d6823b021865936', destinationName: 'Kyoto', imageId: 'b30a4363-5900-4aeb-980c-3dc405664476' },
      { destinationId: 'le_4d22dc28a212a9727b1637817a7e9748', destinationName: 'Hokkaido', imageId: '54b12da1-bbad-4fac-8597-9839598f6532' },
      { destinationId: 'le_ff3b33b71034eb7c9d5c014ccd771fbc', destinationName: 'Hiroshima', imageId: 'df9356c6-4d19-41fb-a698-60f75506fcec' },
      { destinationId: 'le_84a3cac633162a1efcc41009c099c53b', destinationName: 'Hakone', imageId: '49467f98-f083-4ca9-a3d5-8cd80e24ee5d' },
      { destinationId: 'le_e447193f2b83d789c98a82a7ef958736', destinationName: 'Urayasu', imageId: 'd02773a1-179d-41f3-8679-05416c66085a' },
    ],
    le_1608659ea7ec15440fa87763b3f5d700: /* Tokyo multi-city-vicinity */ TOKYO_REC_DESTINATIONS,
    le_cdd0500dc0ef6682fa6ec6d2e6b577c4: /* Tokyo city */ TOKYO_REC_DESTINATIONS,
    le_dd6cfa36ca5f428a6c9824630d3a8a96: /* Osaka multi-city-vicinity */ OSAKA_REC_DESTINATIONS,
    le_ab452534c5ce28c4fbb0e102d4a4fb2e: /* Osaka city */ OSAKA_REC_DESTINATIONS,
    le_c98e367e46aa4e7c4d6823b021865936: /* Kyoto multi-city-vicinity */ KYOTO_REC_DESTINATIONS,
    le_ac10ff1941c540cd87c107330996f4f6: /* Kyoto city */ KYOTO_REC_DESTINATIONS,
  },
  le_757b505cfd34c64c85ca5b5690ee5293: /* United States of America */ {
    le_bd80d53a4b5d3aef9d8a1fabe2feecfc: /* San Francisco multi-city-vicinity */ SAN_FRANCISCO_REC_DESTINATIONS,
    le_fb2606a5068901da92473666256e6e5b: /* San Francisco city */ SAN_FRANCISCO_REC_DESTINATIONS,
    le_324d1d5faac07d0c5ae13c2213b84ea9: /* Las Vegas multi-city-vicinity */ LAS_VEGAS_REC_DESTINATIONS,
    le_ef8446f35513a8d6aa2308357a268a7e: /* Las Vegas city */ LAS_VEGAS_REC_DESTINATIONS,
    le_079230e29195cac1ce62e737740797a0: /* Los Angeles multi-city-vicinity */ LOS_ANGELES_REC_DESTINATIONS,
    le_c8758b517083196f05ac29810b924aca: /* Los Angeles city */ LOS_ANGELES_REC_DESTINATIONS,
    le_1ada7faf229425b786d87f7d9d5d43f2: /* New York multi-city-vicinity */ NEW_YORK_REC_DESTINATIONS,
    le_cc70903297fe1e25537ae50aea186306: /* New York city */ NEW_YORK_REC_DESTINATIONS,
    Generic: [
      { destinationId: 'le_324d1d5faac07d0c5ae13c2213b84ea9', destinationName: 'Las Vegas', imageId: '7e4480a7-ad92-4036-acde-9066f6b7578e' },
      { destinationId: 'le_079230e29195cac1ce62e737740797a0', destinationName: 'Los Angeles', imageId: '6f3f4195-519e-4360-8f93-f3ec009b3607' },
      { destinationId: 'le_bd80d53a4b5d3aef9d8a1fabe2feecfc', destinationName: 'San Francisco', imageId: '9d00c89d-9328-46aa-9bea-7cc29aed4c45' },
      { destinationId: 'le_1ada7faf229425b786d87f7d9d5d43f2', destinationName: 'New York', imageId: '8ad03e09-12e3-448f-8894-773765e2c497' },
      { destinationId: 'le_548026b063092cc5c30e6ea04ccef75c', destinationName: 'Miami', imageId: 'e0047d0a-4272-4457-85dc-30649ec65a1e' },
      { destinationId: 'le_979d472a84804b9f647bc185a877a8b5', destinationName: 'Hawaii', imageId: 'a40dea11-51c6-4c38-8bf1-68ba304392d8' },
    ],
  },
  le_cfecdb276f634854f3ef915e2e980c31: /* England */{
    le_66ff0e7c30438d414ff0a941b759f114 /* London multi-city-vicinity */: LONDON_REC_DESTINATIONS,
    le_51174add1c52758f33d414ceaf3fe6ba: /* London city */ LONDON_REC_DESTINATIONS,
    Generic: EUROPE_GENERIC_REC_DESTINATIONS,
  },
  le_7e7757b1e12abcb736ab9a754ffb617a: /* Spain */{
    le_3cbc4af26e4af14e7d661382d2678fff: /* Barcelona province_state */ BARCELONA_REC_DESTINATIONS,
    le_af15ce7cbd279b1a769d85d1540a5073: /* Barcelona multi-city-vicinity */ BARCELONA_REC_DESTINATIONS,
    Generic: EUROPE_GENERIC_REC_DESTINATIONS,
  },
  le_093f65e080a295f8076b1c5722a46aa2: /* France */ {
    le_cb3f7087c987ceff5b306d4ff89f5db6: /* Paris multi-city-vicinity */ PARIS_REC_DESTINATIONS,
    le_7f7c351ee977c765aa8cd5c7020bc38f: /* Paris city */ PARIS_REC_DESTINATIONS,
    Generic: EUROPE_GENERIC_REC_DESTINATIONS,
  },

  le_93db85ed909c13838ff95ccfa94cebd9: /* Italy */ {
    le_832d851fd4d8851affa0b77077f5b4d6: /* Rome multi-city-vicinity */ ROME_REC_DESTINATIONS,
    le_09d37c08f7b129e96277388757530c72: /* Rome city */ ROME_REC_DESTINATIONS,
    Generic: EUROPE_GENERIC_REC_DESTINATIONS,
  },
  le_12767faf1bf8cafc7594430586c558c2: /* Europe */ {
    Generic: EUROPE_GENERIC_REC_DESTINATIONS,
  },
  le_6c76247fb203bb40dc89857c5e3855ed: /* European Union */ {
    Generic: EUROPE_GENERIC_REC_DESTINATIONS,
  },
  le_43baa6762fa81bb43b39c62553b2970d: /* Dubai (state) */ {
    Generic: [
      { destinationId: 'le_51174add1c52758f33d414ceaf3fe6ba', destinationName: 'London', imageId: '43348077-c6e8-435a-9267-b8a44ab4f131' },
      { destinationId: 'le_cb3f7087c987ceff5b306d4ff89f5db6', destinationName: 'Paris', imageId: '3c8d96c5-2156-4b4b-8fcc-de773c4e3953' },
      { destinationId: 'le_49ae49a23f67c759bf4fc791ba842aa2', destinationName: 'Abu Dhabi', imageId: 'e787ebb5-8cc3-4ce0-955f-57775a7ae2c9' },
      { destinationId: 'le_bd4c9ab730f5513206b999ec0d90d1fb', destinationName: 'Singapore', imageId: '73fe1362-f21b-4e6b-bfb1-ff070ff7b494' },
      { destinationId: 'le_af15ce7cbd279b1a769d85d1540a5073', destinationName: 'Barcelona', imageId: '525819c5-e063-49fe-867a-bcbad50b113e' },
      { destinationId: 'le_1608659ea7ec15440fa87763b3f5d700', destinationName: 'Thailand', imageId: 'a5cc53e9-971e-4a7e-953a-33bda1c0cd84' },
    ],
  },
  le_bd4c9ab730f5513206b999ec0d90d1fb: /*  Singapore */ {
    Generic: [
      { destinationId: 'le_d47bb339212ddfab0fadd99d492a5fc3', destinationName: 'Phuket', imageId: 'e26c1ee7-88b8-4835-bcb5-f8d2eb5cafd9' },
      { destinationId: 'le_7af6d6117d13124fd3e00f5cb5f04400', destinationName: 'Koh Samui', imageId: '58a05961-5f6b-4c51-bd4c-b64fb6e881fe' },
      { destinationId: 'le_9cf81d8026a9018052c429cc4e56739b', destinationName: 'Bangkok', imageId: '932bb8e0-26bf-4267-a249-7298ac2b39dd' },
      { destinationId: 'le_51174add1c52758f33d414ceaf3fe6ba', destinationName: 'London', imageId: '43348077-c6e8-435a-9267-b8a44ab4f131' },
      { destinationId: 'le_e7708a01a999a96c804a6b3c122d31c0', destinationName: 'Hanoi', imageId: '77545fcc-5e80-42cb-a300-627defdd4301' },
      { destinationId: 'le_747d3443e319a22747fbb873e8b2f9f2', destinationName: 'Ho Chi Minh City', imageId: 'cc629b19-f66e-4d7e-8664-e689b86459fa' },
    ],
  },

}
